import React from 'react';


// home styling and images
import '../styles/Home.css';
import sitemaintenance from '../assets/images/site-maintenance.webp';
import ricsStorefront from '../assets/images/rics-storefront.webp';
import lancasterCentral from '../assets/images/lancaster-central-market.jpg';
import headhouseMarket from '../assets/images/headhouse-market.jpg';
import contactUs from '../assets/images/contact-us.jpg';
function Home() {

    return (
        <>
            {/* page title and description */}
            <h1 className='home-header'>Ric's Bread</h1>
            <div className='header-div'>
                <img className='description-img' src={sitemaintenance} alt="Computer that reads 'website maintenance'" />
                <p className="home-description">
                    Our site is currently undergoing some renovations! Thanks for your patience
                    as we develop our look and site utility. Have a suggestion? Send a message to <a className='link' href='mailto: ricsbreadkc@gmail.com'>our email</a>.
                </p>
            </div>
            {/* content on home page */}

            <div className="home-content">

                <div className='home-content-div'>
                    <img className='contact-img' src={contactUs} alt="Computer that reads 'website maintenance'" />
                    <div className='button-div'>
                        <a href='mailto: ricsbreadkc@gmail.com' className='email link'>ricsbreadkc@gmail.com</a>
                    </div>
                   <div className='button-div'>
                        <a href='tel:7173928385' className='email link'>7173928385</a>
                    </div>
                </div>

                
                

                <div className='home-content-div'>
                    <h2>Schedule</h2>
                    <div className='locations-div'>
                        <div className='location-detail'>
                            <h3>Ric's Bread Storefront</h3>
                             <img className='location-img' src={ricsStorefront} alt="Exterior of Ric's Bread bakery" />
                            <address>
                                <a className='address-link link' href='https://maps.app.goo.gl/ftWrp6Gi4n7e6gqS8' target='blank' rel='noreferrer'>
                                    24 N Queen Street 
                                    <br></br>
                                    Lancaster, PA 17603
                                </a>
                            </address>
                            <ul>
                                <li>Monday: 7 AM - 3 PM </li>
                                <li>Tuesday: Closed</li>
                                <li>Wednesday: 7 AM - 3 PM</li>
                                <li>Thursday: 7 AM - 3 PM</li>
                                <li>Friday: 7 AM - 3 PM</li>
                                <li>Saturday: Closed</li>
                                <li>Sunday: Closed</li>
                            </ul>
                            
                        </div>

                        <div className='location-detail'>
                            <h3>Ric's Bread at Lancaster Central Market</h3>
                            <img className='location-img' src={lancasterCentral} alt="Exterior of Lancaster Central Market'" />
                            <address>
                                <a className='address-link link' href='https://maps.app.goo.gl/V4dMCco5jShbH3HNA' target='blank' rel='noreferrer'>
                                    23 N Market Street 
                                    <br></br>
                                    Lancaster, PA 17603
                                </a>
                            </address>
                            <ul>
                                <li>Tuesday: 6 AM - 3 PM</li>
                                <li>Friday: 6 AM - 3 PM</li>
                                <li>Saturday: 6 AM - 3 PM</li>
                            </ul>
                           
                        </div>

                         <div className='location-detail'>
                            <h3>Ric's Bread at Headhouse Farmer's Market</h3>
                            <img className='location-img' src={headhouseMarket} alt="Headhouse Farmer's Market in Philadelphia" />
                            <address>
                                <a className='address-link link' href='https://maps.app.goo.gl/1rGAwmGEEpDozaDc8' target='blank' rel='noreferrer'>
                                    2nd & Lombard Street 
                                    <br></br>
                                    Philadelphia, PA 19147
                                </a>
                            </address>
                            <ul>
                                <li>Sunday: 10 AM - 2 PM</li>
                            </ul>
                            
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Home;